import _ from "lodash";
import PropTypes from "prop-types";
import { append, partial, pipe } from "ramda";
import React, { Component } from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { change as changeFieldValue, getFormValues } from "redux-form";
import * as dataActions from "../../../../../utils/data/dataActions";
import {
  BROKERS,
  CLIENT_BROKER_RELATIONSHIP,
} from "../../../../../utils/data/models";
import { DynamicTable } from "../../../../common/form";
import AssociatedBroker from "./brokers/AssociatedBroker";

const RELATIONSHIP_LIMIT = 5;

class AssociatedBrokers extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.getBrokerData();
  }

  componentDidUpdate(prevProps) {
    const { brokerRelationships, coveragePeriodId } = this.props;
    if (prevProps.coveragePeriodId != coveragePeriodId) {
      this.getBrokerData();
    }
    if (!_.isEmpty(brokerRelationships)) {
      const updatedBrokers = brokerRelationships.filter(
        (broker) =>
          broker.coveragePeriodId == coveragePeriodId ||
          !broker.coveragePeriodId
      );
      const currentBrokers = this.state.filteredBrokers;

      if (
        !currentBrokers ||
        !_.isEqual(updatedBrokers.sort(), currentBrokers.sort())
      ) {
        this.setState({
          filteredBrokers: updatedBrokers,
        });
      }
    }
  }

  componentWillUnmount() {
    const { add } = this.props;
    const { coveragePeriod, coveragePeriodId, broker } = this.props.formValues;
    const currentCoveragePeriodId = coveragePeriod.coveragePeriodId;

    if (
      broker && (add ||
        coveragePeriodId && currentCoveragePeriodId &&
        currentCoveragePeriodId.toString() == coveragePeriodId.toString()
      )
    ) {
      this.props.updateBrokerRelationships(broker);
    }
  }

  getBrokerData() {
    const { getBrokerRelationships, getBrokers, clientId } = this.props;
    if (
      _.isEmpty(this.props.brokerRelationships) ||
      (this.props.brokerRelationships.length &&
        this.props.brokerRelationships.length == 0)
    ) {
      !!clientId && getBrokerRelationships(clientId);
    }
    getBrokers();
  }

  renderHeader = () =>
    [
      "broker",
      "compensationType",
      "calculationTypes",
      "brokerPart",
      "cashAdvance",
      "",
    ]
      .map((name) => (name ? `admin.brokers.${name}` : ""))
      .map((id) => (id ? <FormattedMessage id={id} /> : ""));

  brokerListFull = () =>
    this.state.filteredBrokers &&
    this.state.filteredBrokers.filter((b) => !b.isArchived).length >=
      RELATIONSHIP_LIMIT;

  addEmptyRow = () => {
    const {
      disabled,
      brokerRelationships: relationships,
      updateBrokerRelationships: update,
    } = this.props;

    if (disabled) return;

    const addToRelationships = pipe(append, update);
    !this.brokerListFull() && addToRelationships({}, relationships);
  };

  render() {
    const { disabled, brokers } = this.props;
    return (
      <div className="ClientSubsection--fullWidth">
        <h3>
          <FormattedMessage id="clients.form.sections.associatedBrokers" />
        </h3>
        {!brokers && (
          <span className="loader">
            <FormattedMessage id="clients.form.client.broker.loading" />
          </span>
        )}
        <DynamicTable
          headers={this.renderHeader()}
          addEmptyRow={this.addEmptyRow}
          addButtonDescription={
            <FormattedMessage id="clients.form.client.broker.associatedBrokerLimit" />
          }
          disableAddButton={this.brokerListFull() || disabled || !brokers}
        >
          {this.state.filteredBrokers &&
            this.state.filteredBrokers.map(
              (brokerRelationship, index) =>
                !brokerRelationship.isArchived && (
                  <AssociatedBroker
                    brokerRelationship={brokerRelationship}
                    key={index}
                    rowIndex={index}
                    disabled={disabled}
                    brokers={brokers}
                  />
                )
            )}
        </DynamicTable>
      </div>
    );
  }
}

AssociatedBrokers.propTypes = {
  getBrokerRelationships: PropTypes.func,
  updateBrokerRelationships: PropTypes.func,
  brokerRelationships: PropTypes.array,
  getBrokers: PropTypes.func,
  coveragePeriodId: PropTypes.number,
  historicalcoveragePeriodId: PropTypes.number,
  clientId: PropTypes.number,
  changeFieldValue: PropTypes.func,
  brokers: PropTypes.array,
  disabled: PropTypes.bool,
  clearBrokerRelationships: PropTypes.func,
  interval: PropTypes.number,
  add: PropTypes.bool,
  formValues: PropTypes.object
};

const brokersSelector = (state) =>
  state.data.brokers ? state.data.brokers.items : [];

const mapStateToProps = (state) => ({
  brokerRelationships: state.data.clientBrokerRelationship || {},
  brokers: brokersSelector(state),
  formValues: getFormValues("client")(state),
});

const applyToBrokerRelationships = (fn) =>
  partial(fn, [CLIENT_BROKER_RELATIONSHIP]);

const mapDispatchToProps = {
  getBrokerRelationships: applyToBrokerRelationships(
    dataActions.getRelationshipItems
  ),
  updateBrokerRelationships: applyToBrokerRelationships(
    dataActions.updateLocalData
  ),
  getBrokers: partial(dataActions.getDataList, [
    BROKERS,
    0,
    1000,
    "",
    [BROKERS.creationDateSorter],
    [BROKERS.archiveFilter],
  ]),
  clearBrokerRelationships: partial(dataActions.updateLocalData, [
    CLIENT_BROKER_RELATIONSHIP,
    [],
  ]),
  changeFieldValue,
};
export default connect(mapStateToProps, mapDispatchToProps)(AssociatedBrokers);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client-form/basic-client-sections/ClientAssociatedBrokers.js